import { empty } from 'views/components/php.js';
import moment from 'moment';

require('moment/locale/es');

function get_servicios_adicionales_vacios() {
    return {
        acarreo_origen: '0 a 30 m',
        acarreo_destino: '0 a 30 m',
        armado_muebles: '',
        desarmado_muebles: '',
        cajas_closet: '',
        cajas_desempacadas: '',
        cajas_empacadas: ''
    };
}

function get_solicitud_vacia(clave = '') {
    return {
        clave_empresa_mm: clave,
        correo_adicional: '',
        correo: '',
        dir_destino: '',
        dir_destino2: '',
        dir_origen: '',
        dir_origen2: '',
        elevador_carga: '',
        elevador_carga2: '',
        elevador_descarga: '',
        elevador_descarga2: '',
        fecha_registro: moment().format('YYYY-MM-DD'),
        fecha_requerida: moment().format('YYYY-MM-DD'),
        hora_registro: moment().format('HH:mm:ss'),
        id_crm: '',
        inventario_m3: 0,
        inventario: [],
        nombre_cliente: '',
        notas_adicionales_cliente: '',
        pais: 'MX',
        piso_carga: '9',
        piso_carga2: '',
        piso_descarga: '9',
        piso_descarga2: '',
        servicios_adicionales: get_servicios_adicionales_vacios(),
        status: 'Registro inicial',
        telefono_adicional: '',
        telefono: '',
        tipo_inmueble_destino: 'Casa',
        tipo_inmueble_destino2: '',
        tipo_inmueble_origen: 'Casa',
        tipo_inmueble_origen2: ''
    };
}

function decode_solicitud(sol = {}) {
    if (empty(sol)) {
        return get_solicitud_vacia();
    }

    let aux = null;
    if (!empty(sol.datos_cliente_crm)) {
        aux = JSON.parse(sol.datos_cliente_crm);
        sol.nombre_cliente = !empty(aux.nombre_cliente) ? aux.nombre_cliente : '';
        delete sol.datos_cliente_crm;
    }

    if (!empty(sol.direcciones)) {
        aux = JSON.parse(sol.direcciones);
        sol.dir_origen = !empty(aux.dir_origen) ? aux.dir_origen : '';
        sol.dir_destino = !empty(aux.dir_destino) ? aux.dir_destino : '';
        sol.dir_origen2 = !empty(aux.dir_origen2) ? aux.dir_origen2 : '';
        sol.dir_destino2 = !empty(aux.dir_destino2) ? aux.dir_destino2 : '';
        delete sol.direcciones;
    }

    if (sol.inventario === 'null') {
        sol.inventario = [];
    } else if (empty(sol.inventario)) {
        sol.inventario = [];
    } else if (!empty(sol.inventario)) {
        aux = JSON.parse(sol.inventario);
        sol.inventario = Array.isArray(aux) ? aux : [];
    }

    if (sol.servicios_adicionales === 'null') {
        sol.servicios_adicionales = get_servicios_adicionales_vacios();
    } else if (empty(sol.servicios_adicionales)) {
        sol.servicios_adicionales = get_servicios_adicionales_vacios();
    } else if (!empty(sol.servicios_adicionales)) {
        aux = JSON.parse(sol.servicios_adicionales);
        sol.servicios_adicionales = typeof aux === 'object' ? aux : get_servicios_adicionales_vacios();
    }

    if (empty(sol.tipo_inmueble_origen)) {
        sol.tipo_inmueble_origen = 'Casa';
    }
    if (empty(sol.tipo_inmueble_destino)) {
        sol.tipo_inmueble_destino = 'Casa';
    }

    if (empty(sol.piso_carga)) {
        sol.piso_carga = '9';
    }
    if (empty(sol.piso_descarga)) {
        sol.piso_descarga = '9';
    }

    return sol;
}

export {
    decode_solicitud,
    get_solicitud_vacia
};
